import { ExpenseCategory, DriveCopyStatus } from '@/types/expense'

import api from './config'

export interface ExpenseItem {
  date: string
  category: string
  amount: number
  original_amount: number
  percentage: number
  reference?: string
  operation?: string
  updated_at: string,
  google_drive_status: DriveCopyStatus | null
  sgid: {
    global: string
  }
}

interface ExpenseParams {
  expense_category_code: ExpenseCategory
  amount_cents: number
  percentage: number
  currency?: string
  date: string
  reference?: string
  operation?: string
  calculate_vat_expense?: boolean
  document_signed_id?: string
}

interface IndexExpenseResponse {
  expenses: ExpenseItem[]
}

interface IndexParams {
  year: number
}

const expenseAPI = {
  index: async ({ year }: IndexParams) => {
    const response = await api.get<IndexExpenseResponse>(`/expenses?year=${year}`)
    return response.data
  },
  show: async (id: string) => {
    const response = await api.get<ExpenseItem>(`/expenses/${id}`)
    return response.data
  },
  create: async (data: ExpenseParams) => {
    const response = await api.post<ExpenseItem>('/expenses', { expense: data })
    return response.data
  },
  update: async (id: string, data: ExpenseParams) => {
    const response = await api.put<ExpenseItem>(`/expenses/${id}`, { expense: data })
    return response.data
  },
  delete: async (id: string) => {
    const response = await api.delete(`/expenses/${id}`)
    return response.data
  },
  deleteMonth: async ({ year, month }: { year: number, month: number }) => {
    const response = await api.delete(`/expenses/destroy_month?year=${year}&month=${month}`)
    return response.data
  }
}

export default expenseAPI